"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios = __importStar(require("axios"));
const axios_mock_adapter_1 = __importDefault(require("axios-mock-adapter"));
const lodash_1 = __importDefault(require("lodash"));
const uuid_1 = require("uuid");
__exportStar(require("./types"), exports);
class ApiService {
    constructor({ apiUrl, timeout, }) {
        const connectionConfig = {
            baseURL: apiUrl,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            timeout,
            withCredentials: true,
        };
        this.connection = axios.default.create(connectionConfig);
        this.unauthenticatedHandler = () => { };
        this.requestContextListener = () => { };
        this.responseContextListener = () => { };
        this.connection.interceptors.response.use((response) => response, (error) => {
            const status = lodash_1.default.get(error, 'response.status');
            if (status === 401) {
                this.unauthenticatedHandler();
            }
            return Promise.reject(error);
        });
        this.connection.interceptors.response.use((response) => {
            this.pushResponseContext(response);
            return response;
        }, (error) => {
            const response = lodash_1.default.get(error, 'response');
            if (response) {
                this.pushResponseContext(response);
            }
            return Promise.reject(error);
        });
        this.connection.interceptors.response.use(undefined, (error) => {
            const message = lodash_1.default.get(error, 'message');
            const config = lodash_1.default.get(error, 'config');
            if (config
                && config.retryQty !== 0
                && ['Network Error', 'timeout'].some((e) => message.includes(e))) {
                config.retryQty = typeof config.retryQty === 'undefined' ? 3 : config.retryQty - 1;
                const delayRetryRequest = new Promise((resolve) => {
                    setTimeout(() => {
                        resolve(null);
                    }, config.retryDelay || 3000);
                });
                return delayRetryRequest.then(() => this.connection.request(config));
            }
            return Promise.reject(error);
        });
        this.connection.interceptors.request.use((config) => {
            const requestId = (0, uuid_1.v4)();
            lodash_1.default.set(config, 'headers.X-Request-Id', requestId);
            const startTimestamp = performance.now();
            lodash_1.default.set(config, 'startTimestamp', startTimestamp);
            this.pushRequestContext(config, requestId);
            return config;
        });
        this.mock = null;
        this.path = (v) => {
            if (v.includes(':')) {
                return new RegExp(v.replace(/:\w+/g, '[^/]+'));
            }
            return v;
        };
    }
    setUnauthenticatedHandler({ handler, }) {
        this.unauthenticatedHandler = handler;
    }
    setRequestContextListener({ listener, }) {
        this.requestContextListener = listener;
    }
    setResponseContextListener({ listener, }) {
        this.responseContextListener = listener;
    }
    pushRequestContext(config, requestId) {
        const requestContext = {
            Method: `${(config.method || 'Unknown').toUpperCase()}`,
            RequestData: config.data,
            RequestHeaders: config.headers,
            RequestId: requestId,
            RequestParams: config.params,
            Route: config.url || 'Unknown',
        };
        const cleanRequestContext = lodash_1.default.omitBy(requestContext, lodash_1.default.isUndefined);
        this.requestContextListener(cleanRequestContext);
    }
    pushResponseContext(response) {
        const requestId = lodash_1.default.get(response.config, 'headers.X-Request-Id', '');
        const { config, data, headers, status, } = response;
        const endTimestamp = performance.now();
        const startTimestamp = lodash_1.default.get(config, 'startTimestamp', endTimestamp);
        const responseContext = {
            Duration: endTimestamp - startTimestamp,
            Method: `${(config.method || 'Unknown').toUpperCase()}`,
            RequestData: config.data,
            RequestHeaders: config.headers,
            RequestId: requestId,
            RequestParams: config.params,
            ResponseData: data,
            ResponseHeaders: headers,
            Route: config.url || 'Unknown',
            Status: status,
        };
        const cleanResponseContext = lodash_1.default.omitBy(responseContext, lodash_1.default.isUndefined);
        this.responseContextListener(cleanResponseContext);
    }
    initMock(mockSetup) {
        this.mock = new axios_mock_adapter_1.default(this.connection);
        mockSetup(this.mock);
    }
}
exports.default = ApiService;
